'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushCartErrors = PushCartErrors;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _pushCartActions = require('../../../store/actions/push-cart-actions');

var pushCartActions = _interopRequireWildcard(_pushCartActions);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function PushCartErrors(_ref) {
  var errors = _ref.errors;

  var dispatch = (0, _reactRedux.useDispatch)();

  var handleErrorClose = function handleErrorClose(event, error) {
    var key = error.key;
    var target = event.target;

    dispatch(pushCartActions.toggleError(key));

    target.closest('.psh-Errors_Item').addEventListener('transitionend', function (e) {
      if (e.propertyName === 'visibility') {
        dispatch(pushCartActions.removeError(key));
      }
    });
  };

  return _react2.default.createElement('div', { className: 'psh-Errors' }, errors.map(function (error) {
    return _react2.default.createElement('div', { className: 'psh-Errors_Item', 'aria-hidden': String(!error.show), key: error.key }, error.message, _react2.default.createElement('div', { className: 'psh-Errors_Close', onClick: function onClick(e) {
        return handleErrorClose(e, error);
      } }, _react2.default.createElement('svg', { viewBox: '0 0 13 13', xmlns: 'http://www.w3.org/2000/svg' }, _react2.default.createElement('path', {
      d: 'M7.209 6.499L12.847.848a.495.495 0 0 0-.7-.7L6.5 5.788.861.149a.5.5 0 0 0-.71 0 .48.48 0 0 0 0 .7l5.639 5.65L.15 12.15a.48.48 0 0 0 0 .7.5.5 0 0 0 .35.15.51.51 0 0 0 .36-.15L6.5 7.21l5.648 5.64a.5.5 0 0 0 .35.15.5.5 0 0 0 .36-.85L7.21 6.499z',
      fillRule: 'nonzero'
    }))));
  }));
}

PushCartErrors.propTypes = {
  errors: _propTypes2.default.array.isRequired
};